import { inject, injectable } from "inversify";
import { ClientPortalNewsModel, ICPLClientPortalNewsClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalNewsService {
  getLatestNews(): Promise<ClientPortalNewsModel>;
  getNews(index: number | undefined, pageSize: number | undefined): Promise<ClientPortalNewsModel[]>;
  getNewsPost(developmentNewsID: string): Promise<ClientPortalNewsModel>;
}

@injectable()
export class ClientPortalNewsService implements IClientPortalNewsService {
  @inject(SERVICE_TYPES.CPLClientPortalNewsClient)
  cplClientPortalNewsClient!: ICPLClientPortalNewsClient;

  getLatestNews(): Promise<ClientPortalNewsModel> {
    return this.cplClientPortalNewsClient.getLatestNews();
  }

  getNews(index: number | undefined, pageSize: number | undefined): Promise<ClientPortalNewsModel[]> {
    return this.cplClientPortalNewsClient.getAllNews(index, pageSize);
  }

  getNewsPost(developmentNewsID: string): Promise<ClientPortalNewsModel> {
    return this.cplClientPortalNewsClient.getNewsPost(developmentNewsID);
  }
}
